module.exports = __webpack_public_path__ + "media/media/about/3-7e6445c50b567da4c98c8ad52e0f63d9.jpg";